<script setup>
import { computed } from "vue";
import { BadgeType } from "../../../interfaces/UI";
import ChargemapBadge from "../global/ChargemapBadge.vue";
const props = defineProps({
  totalConnectorsCount: {
    type: Number,
    required: true
  },
  availableConnectorsCount: {
    type: Number,
    required: true
  },
  powerConnector: {
    type: Number,
    required: true
  },
  connectorType: {
    type: Object,
    required: true
  },
  isAllStatic: {
    type: Boolean,
    default: false
  },
  isAllFaulty: {
    type: Boolean,
    default: false
  },
  isAllUnknown: {
    type: Boolean,
    default: false
  },
  legacyApiUrl: {
    type: String,
    required: true
  },
  isB2B: {
    type: Boolean,
    default: true
  },
  isB2CUnauthenticated: {
    type: Boolean,
    default: false
  },
  disabled: {
    type: Boolean,
    default: false
  }
});
const connectorImgUrl = computed(
  () => props.connectorType.icon?.includes(".png") || props.connectorType.icon?.includes(".svg") ? `${props.legacyApiUrl}/medias/v2/connector_types/icon/original/${props.connectorType.id}/${props.connectorType.icon}` : `${props.legacyApiUrl}/medias/v2/connector_types/icon/original/${props.connectorType.id}/${props.connectorType.icon}.png`
);
const getBadgeType = computed(() => {
  if (props.isAllFaulty) {
    return BadgeType.ERROR;
  }
  if (props.isAllStatic || props.availableConnectorsCount === 0) {
    return BadgeType.NEUTRAL;
  }
  if (props.isAllUnknown) {
    return BadgeType.WARNING;
  }
  if (props.availableConnectorsCount > 0) {
    return BadgeType.SUCCESS;
  }
  return BadgeType.NEUTRAL;
});
</script>

<template>
    <div class="w-full">
        <div class="flex px-1 py-2 items-center w-fit gap-0.5">
            <img
                :alt="connectorType.label || $t('connector')"
                :src="connectorImgUrl"
                draggable="false"
                class="h-8 w-8"
                :class="disabled && 'opacity-20'"
                loading="lazy"
            />
            <div
                class="flex flex-col justify-center align-middle"
                :class="
  isB2CUnauthenticated && 'blur-sm select-none pointer-events-none'
"
            >
                <p class="text-xs text-gray-l-500">{{ powerConnector }} kW</p>
                <ChargemapBadge
                    :type="getBadgeType"
                    :disabled
                    custom-text-size="text-xs"
                    class="text-xs w-fit mt-0.5"
                >
                    <div v-if="isAllStatic">
                        <span class="font-semibold">
                            x {{ totalConnectorsCount }}
                        </span>
                    </div>
                    <div v-else-if="isAllUnknown">
                        <span class="font-semibold">
                            ? / {{ totalConnectorsCount }}
                        </span>
                    </div>
                    <div v-else>
                        <span class="font-bold">
                            {{ availableConnectorsCount }}
                        </span>
                        <span>&nbsp;/ {{ totalConnectorsCount }}</span>
                    </div>
                </ChargemapBadge>
            </div>
        </div>
    </div>
</template>
